import { isRejected, Middleware, SerializedError } from '@reduxjs/toolkit';

import { resetTermsOfUse } from '../../features/i18n/i18nSlice';
import { setError, setShowError, setShowTermsOfUse, setTermsOfUseStatus } from '../../features/ui/uiSlice';
import { Errors, TermsOfUseStatus } from '../types';

const handleError = (store, error: SerializedError) => {
  const dispatch = store.dispatch;
  switch (error.name) {
    case Errors.TERMS_OF_USE_NOT_ACCEPTED_ERROR:
      dispatch(setShowTermsOfUse(true));
      dispatch(setTermsOfUseStatus(TermsOfUseStatus.NOT_ACCEPTED));
      dispatch(resetTermsOfUse());
      break;
    case Errors.TERMS_OF_USE_UPDATED_ERROR:
      dispatch(setShowTermsOfUse(true));
      dispatch(setTermsOfUseStatus(TermsOfUseStatus.OLD_VERSION_ACCEPTED));
      dispatch(resetTermsOfUse());
      break;
    case Errors.TOO_MANY_REQUESTS_ERROR:
      dispatch(setShowError(true));
      dispatch(setError({ id: 'SH.SVC.TOOMANYREQUESTS' }));
      break;
    case Errors.HTTP_ERROR:
      break;
    default:
      console.error(`Unexpected error handled: name=[${error.name}], message=[${error.message}]`);
      break;
  }
};

export const errorMiddleware: Middleware = (store) => (next) => (action) => {
  if (isRejected(action)) {
    const { error } = action;
    handleError(store, error);
  }
  return next(action);
};
